import styled from "styled-components";

export const DialogWrapper = styled.div`
  position: fixed;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const FormContainer = styled.div`
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border-radius: 12px;
  padding: 30px 15px 24px;
  width: calc(100% - 80px);
  left: 40px;
  max-width: 400px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 22.4px;
  text-align: left;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 30px;

  > .seed-wrapper {
    display: flex;
    flex-direction: column;
    gap: 3px;
    width: 100%;
    height: 87px;
    border-radius: 9.14px;
    background-image: url("/image-web/reservation/seed-back.svg");
    background-size: cover;
    padding: 20px 16px;

    > .title {
      text-align: left;

      font-weight: 600;
      font-size: 13px;
      color: #ffffffbf;
    }

    > .seed {
      text-align: left;
      font-family: esamanru;
      font-weight: 500;
      font-size: 24px;
      line-height: 100%;
      letter-spacing: 0px;
      color: #fff;
    }
  }

  > .content {
    font-weight: 600;
    font-size: 16px;
    text-align: left;
  }

  > .content-cancel {
    font-weight: 600;
    font-size: 16px;
    text-align: center;
  }

  > .waring {
    font-weight: 600;
    font-size: 11px;
    color: #808080;
    text-align: left;
  }
`;

export const ContentEndWrapper = styled.div`
  font-weight: 600;
  font-size: 16px;
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 20px;

  > .button {
    flex: 1;
    color: #6436e7;

    font-weight: 600;
    font-size: 15px;
    text-align: center;
    height: 48px;
    line-height: 48px;
    border-radius: 8px;

    &.purple {
      color: #fff;
      background: #6436e7;
    }
  }
`;
